import React from 'react';
import styled from 'styled-components';

export default function PhoneInput(props) {
  const { value } = props;

  const digits = value.replace(/[^0-9]/g, '').slice(0, 4).split('');

  return (
    <TopLevelWrapper>
      <NumberBox isFilled={digits.length > 0}>
        <NumberText>{digits[0] ?? ''}</NumberText>
      </NumberBox>
      <NumberBox isFilled={digits.length > 1}>
        <NumberText>{digits[1] ?? ''}</NumberText>
      </NumberBox>
      <NumberBox isFilled={digits.length > 2}>
        <NumberText>{digits[2] ?? ''}</NumberText>
      </NumberBox>
      <NumberBox isFilled={digits.length > 3}>
        <NumberText>{digits[3] ?? ''}</NumberText>
      </NumberBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;

  width: 100%;
`;

const NumberBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20%;
  aspect-ratio: 1;

  border-radius: 12px;
  background-color: ${props => props.isFilled ? '#FDF0E8' : '#ECECEC'};
  border: 1.5px solid ${props => props.isFilled ? '#FF8B48' : '#DFDFDF'};

  transition: all 0.2s ease-in-out;
`;

const NumberText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 24px;
  color: #FF8B48;
  margin: 0;

  @media (min-height: 320px) {
    font-size: 22px;
  }
  @media (min-height: 640px) {
    font-size: 26px;
  }
  @media (min-height: 720px) {
    font-size: 30px;
  }
  @media (min-height: 800px) {
    font-size: 34px;
  }
  @media (min-height: 1000px) {
    font-size: 40px;
  }
  @media (min-height: 1200px) {
    font-size: 48px;
  }
`;
